module.exports = __webpack_public_path__ + "img/check_2.5d91689d.png";